import { http } from '@/plugins/http'
import DataResponse from '@/types/DataResponse'
import PaymentGateway from '@/types/PaymentGateway'
import { AxiosResponse } from 'axios'

export default class PaymentGatewayService {
  index(): Promise<AxiosResponse<DataResponse<PaymentGateway[]>>> {
    return http.get<DataResponse<PaymentGateway[]>>(`/api/v1/office/payment-gateways`)
  }
}
